import { getStaticImageUrl } from '@utils/createImageUrl';

const AdviceAfter = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className="for-lawyer__advice-after-content-container">
      <div className="for-lawyer__advice-after-content">
        <div className="for-lawyer__advice-after-images">
          {isMobile && (
            <img
              className="for-lawyer__advice-after-image for-lawyer-advice-price-img"
              src={getStaticImageUrl({ fileName: 'preview/lawtalk-manager-total-price.png' })}
            />
          )}
          <img
            className="for-lawyer__advice-after-image for-lawyer-advice-list-img"
            src={getStaticImageUrl({ fileName: 'preview/lawtalk-manager-dashboard.png' })}
          />
          <img
            className="for-lawyer__advice-after-image for-lawyer-advice-review-img"
            src={getStaticImageUrl({ fileName: 'preview/lawtalk-manager-review.png' })}
          />
        </div>
        <div className="for-lawyer-dayplus-title view-on-visible">
          <h2 className="for-lawyer-day-title">Day</h2>
          <span className="for-lawyer-day-plus-number-title">+90</span>
        </div>
        <p className="for-lawyer-day-desc view-on-visible">
          3개월 후, 그동안 진행한 상담 리스트와 의뢰인이 남긴 후기를 보니 뿌듯한 마음이 든다.&nbsp;
          {isMobile && <br />}
          여러 편견으로 망설였던 시간이 아까울 정도다. 새로 개업하는 동료가 있다면 적극적으로 추천해야지!
        </p>
        {isMobile && (
          <div className="for-lawyer__slide-circle-container">
            <div className="for-lawyer__slide-circle active" />
            <div className="for-lawyer__slide-circle" />
            <div className="for-lawyer__slide-circle" />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdviceAfter;
